import { record } from "../Record";

export const dateFilter = (timestamp) => {
    const date = new Date(timestamp);
    return date.getDate() + '/' +  date.getMonth() + '/' + date.getFullYear();
}

export const timeFilter = (timestamp) => {
    const date = new Date(timestamp);
    return date.getHours() + ':' + date.getMinutes();
}

export const mapNnFieldto2ListView = (dtoData) => {
    let response = "";
    Object.keys(dtoData).forEach(element => {
        if (Object.keys(dtoData).indexOf(element) === Object.keys(dtoData).length - 1)
            response = response + dtoData[element].name;
        else
            response = response + dtoData[element].name + ", ";
    })
    return response;
}

export const mapNnFieldForm2Dto = (formData) => {
    let response = {}
    Object.keys(formData).forEach(element => {
//        let names = record.transformRecordNames(formData[element]);
        response[element] = {name: formData[element]};
    })
    return response
}

export const mapNnFieldDto2Form = (data) => {
    let response = {}
    Object.keys(data).forEach(element => {
        response[element] = record.recordObject2String(data[element]);
        response[element] = data[element].name;

    })
    return response
}